<template lang="pug">
#content.snap-content
  .overlay
  .header
    .logo-wrapper
      router-link.logo(to="/tournament")
        img.w-100(src="/images/logo/wbet-tournament-logo.png")
    .userpart
      .username-wrapper
        .username
          span.username-text {{ displayName }}
        .balance
          span.currency {{ currencyCode }}
          | {{ availableBalance }}
  .content-center
    .back-btn.d-flex.align-items-center.border-0.p-0(v-if="isNext == 1" @click="goBack") 
      i.fas.fa-left-long.ms-1
      span {{ $t('ui.back') }}
    template(v-if="isNext == 0")
      .select-date-wrapper
        .select-date(ref="tabs" @mousedown="handleMouseDown" @touchstart="handleMouseDown")
          template(v-for="day in days")
            .select-day(:class="{ 'active': compareDates(day, selectedWeekday) }", @click="selectThisWeekday(day)")
              .select-day-wrapper
                .rooms-amount(v-if="getMatchCountByDate(day) > 0") {{ getMatchCountByDate(day) }}
                .select-day-top(v-if="compareDates(day, today)" :class="{ 'today': compareDates(day, selectedWeekday) }") {{ $t('ui.today') }}
                .select-day-top(v-else :class="{ 'today': compareDates(day, selectedWeekday) }")
                  | {{ compareDates(day, today, 1) ? $t('ui.tomorrow') : $t('ui.' + $dayjs(day).format('dddd').toLowerCase()) }}
                .select-day-bottom {{ $dayjs(day).format('MMM DD') }}
      .room-bottom
        .room-rate
          .room-rate-text {{ $t('ui.entry_fee') }}:
          .room-rate-select
            select(v-model="room.rate")
              option(v-for="rate in [20, 50, 100, 200, 500, 1000]" :value="rate")
                | {{ rate }}
                | &nbsp;({{ currencyCode }} {{ $numeral(rate / currency_rate).format('0,0.00') }})
        .room-limit.me-2
          .room-limit-text {{ $t('ui.players') }}:
          .room-limit-select
            select(v-model="room.limit")
              option(v-for="limit in [3,4,5,6,7,8,9,10,12,15,20,30,50,80,100]" :value="limit") {{ limit }}
        .room-limit.me-2
          .room-limit-text {{ $t('ui.winner') }}:
          .room-limit-select
            select(v-model="room.formula")
              option(value="1") 3
              option(value="2") 1
        .room-limit
          .room-limit-text {{ $t('ui.password') }}:
          .room-rate-input
            input.form-control(type="text" v-model="password" :placeholder="$t('message.pin_code')" style="width: 100px;" minlength="6" maxlength="6" pattern="[0-9]*" inputmode="numeric" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false")
          small.room-limit-text.ms-2(style="color: #00ff0088;" v-if="feedback.password") {{ feedback.password }}.room-title
      .room-title
        .room-title-left {{ $t('ui.select_matches') }}
        .room-title-right(v-if="selected.length < maxMatch")
          | {{ $t('ui.selected') }}
          span.room-match-no {{ selected.length }}
          | {{ $t('ui.matches') }}
        .room-title-right.blink(v-else)
          | {{ $t('error.maxMatch').replace('{max}', selected.length.toString()) }}
      template(v-if="loading.getMatchLookup")
        .loader-wrapper
          .loader.pf
      template(v-else)
        template(v-if="matchList[selectedWeekdayFormatted] != null && Object.keys(matchList[selectedWeekdayFormatted]).length > 0")
          .room-wrapper.create-room
            .room-match-wrapper
              .room-league-wrapper(v-for="league in matchList[selectedWeekdayFormatted]")
                .select-league-title
                  .select-league-box.room-league.room-create.collapsed(
                    data-bs-toggle='collapse'
                    :data-bs-target="'#room-create-league-' + league.league_id"
                    aria-expanded='false'
                    :aria-controls="'room-create-league-' + league.league_id"
                    @click="collapseRoomLeague(league.league_id)"
                  )
                    .select-league-checkbox
                      label.date-check
                        input(type="checkbox" @change="toggleLeague($event.target, league)" :checked="checkLeague(selectedWeekdayFormatted, league.league_id)")
                        span.checkmark-date
                    .league-logo
                      img(v-if="league.logo" :src="getLogo('league', league.logo)")
                    .tournament-text.flex-fill
                      | {{ getLeagueName(league) }}
                    .tournament-arrow
                      i.fas.ms-2.fa-chevron-down
                .room-matches.collapse(:id="'room-create-league-' + league.league_id")
                  .room-group(v-for="match in league.matches")
                    .room-match.d-flex(:class="{ 'selected': selected.includes(match.match_id) }" @click="toggleMatch(match.match_id)")
                      .select-league-checkbox
                        label.date-check
                          input(type="checkbox" :checked="selected.includes(match.match_id)" @change="toggleCheckbox(match.match_id, $event.target)")
                          span.checkmark-date
                      .date(v-if="match.match_time") {{ $dayjs(match.match_time).format("MM/DD") }}
                        span.time {{ $dayjs(match.match_time).format("hh:mm A") }}
                      .date(v-else) --:--
                      .team
                        | {{ getName('home_name', match) }}
                        span.home-vs-away -vs-
                        | {{ getName('away_name', match) }}
        template(v-else)
          .note-panel.text-center {{ $t('message.no_matches') }}
    template(v-else)
      .content-center-body
        .joinroom.create
          .pagepanel
            .page-group.pt-0
              .tc-content
                iframe(:src="rulesUrl" loading="lazy")
                .tc-footer
                  .d-flex.agreement.align-items-center
                    .select-league-checkbox.me-1
                      label.date-check
                        input(type="checkbox" v-model="isAgree")
                        span.checkmark-date
                    label.form-check-label 
                      | {{ $t("message.accept_terms") }}
  ul.nav.nav-pills.tournament-pills
    li.nav-item(v-if="selected.length >= 3 && password != null && password != ''")
      a(href="javascript:void(0)" @click="proceedNext")
        template(v-if="isNext == 0")
          .nav-link.tnm-betslip
            i.fas.fa-chevron-circle-right.mr-2
            | {{ $t('ui.next') }}
        template(v-else)
          .nav-link.tnm-betslip(:class="{ 'disabled': loading.roomCreate || !isAgree }")
            template(v-if="isNext == 0")
              i.fas.fa-chevron-circle-right.mr-2
              | {{ $t('ui.next') }}
            template(v-else)
              i.fa.fa-plus.mr-2
              | {{ $t('ui.create_room') }}
    li.nav-item.flex-fill
      router-link(to="/tournament/home" @click="$emit('room-leave')")
        .nav-link.tnm-mybet
          i.fas.fa-door-open.mr-2
          | {{ $t('ui.leave_room') }}

</template>

<script>
import config from "@/config";
import errors from "@/errors";
import { EventBus } from "@/library/_event-bus.js";
import service from "@/views/tournament/library/_xhr.js";
import vPagination from "vue-plain-pagination";

import { required, numeric, minLength, maxLength } from "vuelidate/lib/validators";

export default {
  components: {
    vPagination
  },
  data() {
    return {
      maxMatch: 10,
      isAgree: false,
      isNext: 0,
      collapseAll: false,
      selected: [],
      days: [],
      today: new Date(),
      selectedWeekday: new Date(),
      matchList: {},
      pages: {},
      loading: {
        getMatchLookup: false,
        roomCreate: false,
        validateTournament: false
      },
      room: {
        rate: 100,
        limit: 10,
        formula: 1
      },
      password: "",
      feedback: {
        password: "",
        timeout: null
      },
      currency_rate: 0,
      bootstrapPaginationClasses: {
        ul: "pagination justify-content-center",
        li: "page-item",
        liActive: "active",
        liDisable: "pagination-item--disable",
        button: "page-link",
        buttonActive: "active",
        buttonDisable: "disable"
      },
      paginationAnchorTexts: {
        first: "&laquo;",
        prev: "&lsaquo;",
        next: "&rsaquo;",
        last: "&raquo;"
      },

      drag: false,
      startX: 0,
      clickStart: 0
    };
  },
  validations: {
    password: {
      required,
      numeric,
      minLength: minLength(6),
      maxLength: maxLength(6)
    }
  },
  computed: {
    logoPath() {
      return config.logoPath;
    },
    cnyMode() {
      return config.cnyMode;
    },
    xmasMode() {
      return config.xmasMode;
    },
    logoCNYPath() {
      return config.logoCNYPath;
    },
    logoXMASPath() {
      return config.logoXMASPath;
    },
    currencyCode() {
      return this.$store.getters.currencyCode.replace("UST", "USDT");
    },
    nickname() {
      return this.$store.getters.nickName;
    },
    wallet() {
      if (this.$store.getters.playerWallet) return this.$store.getters.playerWallet;
      return null;
    },
    balance() {
      return this.$store.getters.balance;
    },
    availableBalance() {
      if (this.wallet) {
        return this.$numeral(this.balance).format("0,0.[00]");
      }
      return "-";
    },
    account_id() {
      return this.$store.getters.accountId;
    },
    displayName() {
      if (this.nickname) return this.nickname;
      else return this.account_id;
    },
    selectedWeekdayFormatted() {
      return this.$dayjs(this.selectedWeekday).format("YYYY-MM-DD");
    },
    todayFormatted() {
      return this.$dayjs(this.today).format("YYYY-MM-DD");
    },
    language() {
      return this.$store.getters.language;
    },
    pageSize() {
      return 100;
    },
    rulesUrl() {
      var lang = "en";
      switch (this.$store.getters.language) {
        case "en":
        case "cn":
          // case "id":
          // case "kr":
          // case "th":
          // case "tw":
          // case "vi":
          lang = this.$store.getters.language;
          break;
        default:
          lang = "en";
      }
      return config.rulesUrl + "/tournament/mrules-" + lang + ".html";
    }
  },
  destroyed() {},
  mounted() {
    this.generateThisWeek();
    this.getMatchLookup();
    window.addEventListener("mousemove", this.handleMouseMove);
    window.addEventListener("mouseup", this.handleMouseUp);
    window.addEventListener("touchmove", this.handleMouseMove);
    window.addEventListener("touchend", this.handleMouseUp);
  },
  beforeUnmount() {
    window.removeEventListener("mousemove", this.handleMouseMove);
    window.removeEventListener("mouseup", this.handleMouseUp);
    window.removeEventListener("touchmove", this.handleMouseMove);
    window.removeEventListener("touchend", this.handleMouseUp);
  },
  methods: {
    cancel() {
      this.isAgree = false;
      this.isNext = 0;
    },
    checkLeague(e, f) {
      var m = this.matchList[e][f]["matches"];
      var r = false;
      for (var n = 0; n < m.length; n++) {
        r = this.selected.includes(m[n].match_id);
        if (r == false) break;
      }

      return r;
    },
    toggleLeague(e, f) {
      // loop f.matches to get the match_id and push to this.selected if e.checked is true and not in this.selected
      // if e.checked is false, loop this.selected to remove the match_id if it is in this.selected
      if (e.checked) {
        if (f.matches.length + this.selected.length < this.maxMatch) {
          for (var i = 0; i < f.matches.length; i++) {
            if (this.selected.indexOf(f.matches[i].match_id) == -1) {
              this.selected.push(f.matches[i].match_id);
            }
          }
        } else {
          e.checked = false;
          this.$swal("Warning", this.$t("message.over_max_match"), "warning");
        }
      } else {
        for (var i = 0; i < f.matches.length; i++) {
          if (this.selected.indexOf(f.matches[i].match_id) != -1) {
            this.selected.splice(this.selected.indexOf(f.matches[i].match_id), 1);
          }
        }
      }
    },
    toggleAllLeagues() {
      // used jquery and bootstrap collapse to toggle all .select-league
      if (this.collapseAll === false) {
        $(".room-matches").collapse("show");
        this.collapseAll = true;
      } else {
        $(".room-matches").collapse("hide");
        this.collapseAll = false;
      }
    },
    toggleMatch(e) {
      if (this.selected.includes(e)) {
        this.selected.splice(this.selected.indexOf(e), 1);
      } else {
        if (this.selected.length < this.maxMatch) {
          this.selected.push(e);
        }else{
          this.$swal("Warning", this.$t("message.over_max_match"), "warning");
        }
      }
    },
    toggleCheckbox(e, event) {
      if (!this.selected.includes(e)) {
        event.checked = false;
        return;
      }
    },
    getMatchCountByDate(day) {
      var count = 0;
      var d = this.$dayjs(day).format("YYYY-MM-DD");

      if (this.matchList[d]) {
        // get keys from object matchList
        var keys = Object.keys(this.matchList[d]);
        for (var i = 0; i < keys.length; i++) {
          // get value of key
          var value = this.matchList[d][keys[i]];

          for (var j = 0; j < value.matches.length; j++) {
            if (this.selected.includes(value.matches[j].match_id)) {
              count++;
            }
          }
        }
      }
      return count;
    },
    getName(p, e) {
      var name = e[p + "_" + this.language];
      if (name == null || name == "" || !name) {
        name = e[p];
      }
      return name;
    },
    getLeagueName(e) {
      var name = e["name_" + this.language];
      if (name == null || name == "" || !name) {
        name = e.league_name;
      }
      return name;
    },
    getLogo(p, e) {
      return config.flagPath + p + "/" + e;
    },
    compareDates(date1, date2, day = 0) {
      return date1.getDate() === date2.getDate() + day && date1.getMonth() === date2.getMonth() && date1.getFullYear() === date2.getFullYear();
    },
    generateThisWeek() {
      this.cancel();
      this.selected = [];
      this.days = [];
      this.today = new Date();
      for (let i = 0; i < 30; i++) {
        const date = new Date(this.today);
        date.setDate(date.getDate() + i);
        this.days.push(date);
      }
    },
    selectThisWeekday(e) {
      this.selectedWeekday = e;
      this.getMatchLookup();
    },
    changePage(e) {
      this.pages[this.selectedWeekdayFormatted].value = e;
      this.getMatchLookup();
    },
    getMatchLookup() {
      var d = this.selectedWeekdayFormatted;
      var p = 1;
      // check if pages object has key
      if (this.pages[d]) {
        p = this.pages[d].value;
      } else {
        this.pages[d] = {
          value: 1,
          count: 1,
          total: 0
        };
      }
      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        sports_type: 1,
        match_date: d,
        page_number: p,
        page_size: this.pageSize,
        currency_code: this.$store.getters.currencyCode
      };

      var feedback = {
        success: false,
        status: errors.session.invalidSession
      };

      this.loading.getMatchLookup = true;
      service.getMatchLookup(config.tournamentUrl().matchlookup, json).then(
        result => {
          this.loading.getMatchLookup = false;
          if (result) {
            feedback.success = result.success;
            feedback.status = result.status;
            if (result.success == true) {
              var rate = result.data.rate;
              if (rate != null) {
                this.currency_rate = rate;
              }

              var matches = result.data.value;

              // group by league_id
              var leagues = {};
              matches.forEach(match => {
                if (!leagues.hasOwnProperty(match.league_id)) {
                  leagues[match.league_id] = {
                    league_id: match.league_id,
                    league_name: match.league_name,
                    logo: match.logo,
                    name_kr: match.name_kr,
                    name_en: match.name_en,
                    name_cn: match.name_cn,
                    name_jp: match.name_jp,
                    name_th: match.name_th,
                    name_vn: match.name_vn,
                    name_id: match.name_id,
                    name_my: match.name_my,
                    matches: []
                  };
                }
                // push match to league
                leagues[match.league_id].matches.push(match);
              });

              if (!this.matchList.hasOwnProperty(d)) {
                this.$set(this.matchList, d, {});
              }
              if (!this.pages.hasOwnProperty(d)) {
                this.$set(this.pages, d, {
                  value: 1,
                  count: 1,
                  total: 0
                });
              }
              this.$set(this.matchList, d, leagues);
              if (matches.length > 0) {
                this.pages[d].total = matches[0].totalrows;
                if (this.pages[d].total % this.pageSize != 0) this.pages[d].count = Math.ceil(parseFloat(this.pages[d].total) / parseFloat(this.pageSize));
                else this.pages[d].count = parseFloat(this.pages[d].total) / parseFloat(this.pageSize);
              } else {
                this.pages[d].count = 1;
                this.pages[d].value = 1;
                this.pages[d].total = 0;
              }
            } else {
              this.$helpers.handleFeedback(feedback.status);
            }
          }
        },
        err => {
          console.log(err);
          this.loading.getMatchLookup = false;
          feedback.success = false;
          feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    toggleSelection(e) {
      this.selected.includes(e) ? this.selected.splice(this.selected.indexOf(e), 1) : this.selected.push(e);
    },
    proceedNext() {
      if (this.isNext == 0) {
        this.isNext = 1;
      } else {
        if (this.isAgree) {
          this.validateTournament(this.askForConfirmation);
        }
      }
    },
    askForConfirmation() {
      // must invoke touch to validate the errors
      this.$v.$touch();
      clearTimeout(this.feedback.timeout);

      if (!this.$v.$invalid) {
        this.$swal
          .fire({
            title: this.$t("ui.create_room"),
            text: this.$t("message.are_you_sure"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: this.$t("ui.yes")
          })
          .then(result => {
            if (result.value) {
              this.roomCreate();
              // close this modal #room-create using bootstrap modal
              // $("#room-create").modal("hide");
            }
          });
      } else {
        this.loading.roomCreate = false;
        this.reset();
        this.feedback.password = this.$t("message.room_password_rule");
      }

      // reset the error message after 10 s
      this.feedback.timeout = setTimeout(() => {
        this.reset();
        this.$v.$reset();
      }, 5000);
    },
    validateTournament(callback) {
      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken
      };

      var feedback = {
        success: false,
        status: errors.session.invalidSession
      };

      this.loading.validateTournament = true;
      service.validateTournament(json).then(
        result => {
          this.loading.validateTournament = false;
          if (result) {
            feedback.success = result.success;
            feedback.status = result.status;

            if (result.success == true) {
              if (result.data.result === "true") {
                if (callback) callback();
              } else {
                this.$helpers.handleFeedback("tournamentDisabled");
              }
            } else {
              this.$helpers.handleFeedback(feedback.status);
            }
          }
        },
        err => {
          console.log(err);
          this.loading.validateTournament = false;
          feedback.success = false;
          feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    reset() {
      this.feedback.password = "";
      // this.password = "";
    },
    roomCreate() {
      if (this.loading.roomCreate) {
        return;
      }

      // check selected is not empty else show error
      if (this.selected.length == 0) {
        this.$helpers.handleFeedback("noMatchSelected");
        return;
      }

      // check room rate must be number and between 10 to 1000 else show error
      if (isNaN(this.room.rate) || this.room.rate < 10 || this.room.rate > 1000) {
        this.$helpers.handleFeedback("invalidRoomRate");
        return;
      }

      // check room limit must be number and between 3 to 100 else show error
      if (isNaN(this.room.limit) || this.room.limit < 3 || this.room.limit > 100) {
        this.$helpers.handleFeedback("invalidRoomLimit");
        return;
      }

      // check room password must be string and 6 digit number else show error
      if (isNaN(this.password) || this.password.length != 6) {
        this.$helpers.handleFeedback("invalidRoomPassword");
        return;
      }

      // make selected into comma separated string using non async function (for loop)
      var matchIds = "";
      for (let i = 0; i < this.selected.length; i++) {
        if (i == 0) {
          matchIds = this.selected[i];
        } else {
          matchIds = matchIds + "," + this.selected[i];
        }
      }

      var operator_type = this.$store.getters.operatorType;
      var parent_id = this.$store.getters.parentId;

      // make json
      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        match: matchIds,
        room_type: 2,
        room_rate: this.room.rate,
        room_limit: this.room.limit,
        room_pwd: this.password,
        operator_type: operator_type,
        parent_id: parent_id,
        pay_type: 2,
        formula: Number(this.room.formula)
      };

      // show json
      // console.log(json);

      var feedback = {
        success: false,
        status: errors.session.invalidSession
      };

      var url = config.tournamentUrl().roomcreate;
      if (operator_type && operator_type == 2) {
        url = config.tournamentUrl().vroomcreate;
      }

      this.loading.roomCreate = true;
      service.roomCreate(url, json).then(
        result => {
          this.loading.roomCreate = false;
          if (result) {
            feedback.success = result.success;
            feedback.status = result.status;
            if (result.success == true) {
              // clear all the local variables
              this.selected = [];
              this.room = {
                rate: 100,
                limit: 10,
                password: ""
              };
              this.matchList = {};

              var room_id = 0;
              if (result.data.value[0]) {
                room_id = result.data.value[0].room_id;
              }

              this.$router
                .push({
                  path: "/tournament/home",
                  query: {
                    triggerFunction: true,
                    roomID: room_id
                  }
                })
                .catch(err => {});
            } else {
              if (feedback.status == "maxMatch") {
                this.$swal("Error", this.$t("error.maxMatch").replace("{max}", this.maxMatch.toString()), "error").then(result => {});
              } else {
                this.$helpers.handleFeedback(feedback.status, true);
              }
            }
          }
        },
        err => {
          console.log(err);
          this.loading.roomCreate = false;
          feedback.success = false;
          feedback.status = errors.request.failed;
          // this.$helpers.handleFeedback(err.status);
          if (err.status == "maxMatch") {
            this.$swal("Error", this.$t("error.maxMatch").replace("{max}", this.maxMatch.toString()), "error").then(result => {});
          } else {
            this.$helpers.handleFeedback(err.status, true);
          }
        }
      );
    },

    collapseRoomLeague(e) {
      if ($('.room-league[data-bs-target="#room-create-league-' + e + '"] ').hasClass("collapsed") === true) {
        $('.room-league[data-bs-target="#room-create-league-' + e + '"] .tournament-arrow i')
          .addClass("fa-chevron-down")
          .removeClass("fa-chevron-up");
      } else {
        $('.room-league[data-bs-target="#room-create-league-' + e + '"] .tournament-arrow i')
          .removeClass("fa-chevron-down")
          .addClass("fa-chevron-up");
      }
    },
    goBack() {
      this.isNext = 0;
    },
    getX(e) {
      return e.touches ? e.touches[0].pageX : e.pageX;
    },

    handleMouseDown(e) {
      const tabs = this.$refs.tabs;
      this.drag = true;
      this.startX = this.getX(e) + tabs.scrollLeft;
      this.clickStart = tabs.scrollLeft;
      tabs.classList.add("dragging");
    },

    handleMouseMove(e) {
      if (!this.drag) return;
      e.preventDefault();
      const tabs = this.$refs.tabs;
      tabs.scrollLeft = this.startX - this.getX(e);
    },

    handleMouseUp() {
      this.drag = false;
      const tabs = this.$refs.tabs;
      if (!!tabs) tabs.classList.remove("dragging");
    }
  }
};
</script>
